export default __webpack_public_path__ + "static/media/5-1.5036fb2d.mp3";